import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const AttributesSchema = Yup.object({
  ean: Yup.string()
    .matches(validationPatterns.numberWithString, msg("lettersNumbersOnly"))
    .max(255, msg("eanMax")),
  vintage: Yup.string()
    .required(msg("vintageRequired"))
    .matches(validationPatterns.vintage, msg("vintageFormat")),

  fat: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  saturated_fat: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  carbohydrate: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  sugar: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  protein: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  salt: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  energy: Yup.string()
    .matches(validationPatterns.energy, msg("energyFormat"))
    .max(255, msg("energyMax")),

  name: Yup.string()
    .required(msg("nameRequired"))
    .max(255, msg("max255")),

  description: Yup.string().required(msg("descriptionRequired")),
  winery: Yup.string()
    .required(msg("wineryRequired"))
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),

  denomination: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),

  gradation: Yup.string()
    .required(msg("gradationRequired"))
    .matches(validationPatterns.decimal, msg("percentFormat")),
  vinification: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  terroir: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  region: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),

  format: Yup.string().matches(
    validationPatterns.decimal,
    msg("percentFormat")
  ),

  ingredients: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  fermentation: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  colour: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  taste: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
  pairing: Yup.string()
    .matches(validationPatterns.name, msg("onlyLetters"))
    .max(255, msg("max255")),
});
